import PropTypes from "prop-types";
import { useEffect } from "react";
import ConfirmDialogContainer from "../../component/common/ConfirmDialogContainer";
import JwtExpiredModalDialog from "../../component/app/JwtExpiredModalDialog";
import { Navigate, Route, Routes } from "react-router-dom";
import TemplateListContainer from "./templateList/TemplateListContainer";
import SurveyEditorContainer from "./surveyEditor/SurveyEditorContainer";
import SurveyVersionCompareContainer from "./surveyCompare/SurveyVersionCompareContainer";
import SurveyRunnerContainer from "./surveyRunner/SurveyRunnerContainer";
import RespondentsOverviewContainer from "./respondentsOverview/RespondentsOverviewContainer";
import RespondentDetailsContainer from "./respondentsOverview/RespondentDetailsContainer";
import ChartsContainer from "./reports/Charts/ChartsContainer";
import CollapsibleContainer from "./reports/Tables/CollapsibleTableChartContainer";
import IndicatorAdminContainer from "./indicatorAdmin/IndicatorAdminContainer";
import IndicatorManagementContainer from "./indicatorAdmin/IndicatorManagementContainer";
import UserManagementContainer from "./userManagement/UserManagementContainer";
import QuestionLibraryOverviewContainer from "./surveyEditor/questionLibrary/QuestionLibraryOverviewContainer";
import MasterDataManagementContainer from "./masterDataManagement/MasterDataManagementContainer";
import RoleManagementContainer from "./roleManagement/RoleManagementContainer";
import UserProfileContainer from "./userProfile/UserProfileContainer";
import LoginContainer from "../login/LoginContainer";
import { PreventDirectURLCall } from "../../common/PreventDirectURLCall";

const INTERVAL_IN_MILLISECONDS = 60000;

const UserArea = ({ jwtExpired, doLogout, callJwtVerification, isLoggedIn, role }) => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      callJwtVerification();
    }, INTERVAL_IN_MILLISECONDS);

    return () => {
      clearInterval(intervalId);
    };
  });

  return isLoggedIn ? (
    <>
      <Routes>
        <Route path="templates" Component={TemplateListContainer} />
        <Route
          path="build"
          element={
            <PreventDirectURLCall roles={role}>
              <SurveyEditorContainer />
            </PreventDirectURLCall>
          }
        />
        <Route
          path="compare"
          element={
            <PreventDirectURLCall roles={role}>
              <SurveyVersionCompareContainer />
            </PreventDirectURLCall>
          }
        />
        <Route
          path="surveyRunner"
          element={
            <PreventDirectURLCall roles={role}>
              <SurveyRunnerContainer />
            </PreventDirectURLCall>
          }
        />
        <Route path="respondentsOverview" Component={RespondentsOverviewContainer} />
        <Route
          path="respondentDetails"
          element={
            <PreventDirectURLCall roles={role}>
              <RespondentDetailsContainer />
            </PreventDirectURLCall>
          }
        />
        <Route path="reports/charts" Component={ChartsContainer} />
        <Route path="reports/tables" Component={CollapsibleContainer} />
        <Route path="indicatorAdmin" Component={IndicatorAdminContainer} />
        <Route path="indicatorManagement" Component={IndicatorManagementContainer} />
        <Route path="userManagement" Component={UserManagementContainer} />
        <Route path="questionLibrary" Component={QuestionLibraryOverviewContainer} />
        <Route
          path="masterDataManagement/:paramFundingArea?/:paramProgram?/:paramProgramInstance?"
          Component={MasterDataManagementContainer}
        />
        <Route path="roleManagement" Component={RoleManagementContainer} />
        <Route path="profile" Component={UserProfileContainer} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <JwtExpiredModalDialog show={jwtExpired} onClose={doLogout} />
      <ConfirmDialogContainer />
    </>
  ) : (
    <LoginContainer />
  );
};

UserArea.propTypes = {
  jwtExpired: PropTypes.bool.isRequired,
  doLogout: PropTypes.func.isRequired,
  callJwtVerification: PropTypes.func.isRequired
};

export default UserArea;
